export default {
  jp: {
    title: {
      services: '利用可能サービス'
    },
    label: {
    },
    ph: {
    },
    button: {
    },
    desc: {
      footer: '本サイトで使用している文章・画像等の無断での複製・転載を禁止します。'
    }
  },
  en: {
    title: {
      services: 'Services'
    },
    label: {
    },
    ph: {
    },
    button: {
    },
    desc: {
      footer: 'Unauthorized use of text, images and photographs of this site are strictly prohibited.'
    }
  }
}
